/**
 * What is left of the Claims "mode" once it is gone.
 *
 * Claims used to carry a shape — Simple, Advanced, Advanced+Monthly, later three presets. All of them
 * described the same section at different levels of detail: it ends in Total due, and what varied was
 * which of the components behind it were asked for, and whether rent was entered month by month. Those
 * are questions about which fields are placed, which a firm answers in the builder — so there is no
 * mode left to store, and nothing reads one back.
 *
 * Only the derived question survives: does Total due add itself up, or does the client type it?
 */

/** The monthly rent breakdown — an ordinary field, offered alongside Rent Owed rather than instead of it. */
export const MONTHLY_RENT_FIELD = 'past_due_rent_history';

/** The fields that add up into Total due. With none of them placed, there is nothing to sum. */
export const CLAIMS_COMPONENT_FIELDS: string[] = [
  'past_due_rent',
  MONTHLY_RENT_FIELD,
  'late_fees',
  'damages',
  'costs',
  'civil_recovery_fees',
  'attorney_fee',
  'partial_payments'
];

/** Total due has one binding and two provenances: the client typed it, or we added it up. */
export enum TotalDueProvenance {
  ENTERED = 'ENTERED',
  CALCULATED = 'CALCULATED'
}
